__turbopack_context__.v({
  "navBtn": "SliderNavButtons-module__LsvwVW__navBtn",
  "navBtnWrapper": "SliderNavButtons-module__LsvwVW__navBtnWrapper",
});
